import OrderedList from '@tiptap/extension-ordered-list'

export const CustomOrderedList = OrderedList.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      dir: {
        default: null,
        parseHTML: element => element.getAttribute('dir'),
        renderHTML: attributes =>
          attributes.dir ? { dir: attributes.dir } : {},
      },
    }
  },
  addInputRules() {
    return []
  },
})
